import ColorsShadesList from './ColorsShadesList'

export default ColorsShadesList
